<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { FieldChange } from "@/model/change";
import { isUnset } from "@/model/change";
import { useCardStore } from "@/store/card";

const props = defineProps<{ stickyId: string; field: FieldChange<number> }>();

const priorities = useCardStore().cards[props.stickyId]?.type.priorities;

function name(value?: number) {
  return value === undefined ? "" : priorities?.[value]?.text || value;
}
</script>

<template>
  <div class="change horizontal">
    <template v-if="!isUnset(field.old)">
      <span class="change-value">{{ name(field.old) }}</span>
      <SvgIcon
        name="arrow/right"
        width="20"
        height="20"
        role="img"
        :aria-label="$t('label.cardDiff.changedTo')"
      />
    </template>
    <span class="change-value">{{ name(field.new) }}</span>
  </div>
</template>
